import React from "react";
import LandingPageLayout from "../../shared/Layouts/LandingPageLayout";
import {
  CHEVRON_RIGHT_WHITE,
  EMAIL_OUTLINE,
  LOCATION_OUTLINE,
  PHONE_OUTLINE,
} from "../../assets";
import ButtonV2 from "../../shared/components/buttonV2";

function ContactUs() {
  return (
    <LandingPageLayout
      title={<>Get In Touch With Us</>}
      currentLink={"Get Touch With Us"}
    >
      <div className="w-full flex flex-col lg:flex-row items-start justify-between px-4 sm:px-8 lg:px-20 gap-6 lg:gap-5 py-8 sm:py-10">
        <div className="w-full p-5 sm:p-6 lg:p-7 rounded-lg bg-globalGreen flex flex-col items-start gap-y-4 sm:gap-y-5 order-2 lg:order-1">
          <div className="w-fit p-2 bg-white text-black rounded-3xl text-xs sm:text-sm">
            Contact Us
          </div>
          <span className="text-white font-semibold text-xl sm:text-2xl lg:text-[32px] leading-relaxed">
            Need Help or Have Questions? <br /> Get in Touch
          </span>
          <span className="text-sm sm:text-[16px] font-normal text-white leading-relaxed">
            We're here to assist you with inquiries related to customary law
            matters, appeals, judgments, and court processes. Reach out to us
            today — our team is ready to provide guidance and support.
          </span>
          <div className="w-full flex flex-col sm:flex-wrap sm:flex-row justify-between gap-y-4 sm:gap-y-5">
            <div className="flex items-start gap-x-2 sm:gap-x-3">
              <img
                src={PHONE_OUTLINE}
                className="w-[18px] sm:w-[20px] h-[18px] sm:h-[20px] mt-1"
                alt="Phone Icon"
              />
              <div className="flex items-start flex-col gap-y-1">
                <span className="text-sm sm:text-[16px] font-normal text-white">
                  Phone Number
                </span>
                <span className="text-sm sm:text-[16px] font-normal text-white">
                  +2348063461258
                </span>
              </div>
            </div>
            <div className="flex items-start gap-x-2 sm:gap-x-3">
              <img
                src={EMAIL_OUTLINE}
                className="w-[18px] sm:w-[20px] h-[18px] sm:h-[20px] mt-1"
                alt="Email Icon"
              />
              <div className="flex items-start flex-col gap-y-1">
                <span className="text-sm sm:text-[16px] font-normal text-white">
                  Email Address
                </span>
                <span className="text-sm sm:text-[16px] font-normal text-white">
                  admin@judiciary.en.gov.ng
                </span>
              </div>
            </div>
            <div className="flex items-start gap-x-2 sm:gap-x-3">
              <img
                src={LOCATION_OUTLINE}
                className="w-[18px] sm:w-[20px] h-[18px] sm:h-[20px] mt-1"
                alt="Location Icon"
              />
              <div className="flex items-start flex-col gap-y-1">
                <span className="text-sm sm:text-[16px] font-normal text-white">
                  Office Location
                </span>
                <span className="text-sm sm:text-[16px] font-normal text-white leading-relaxed">
                  No. 5, Aguleri Street <br /> Independence Layout, P.M.B <br />
                  1461, Enugu State
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full h-full flex items-center justify-center order-1 lg:order-2">
          <div className="w-full shadow-container flex p-4 sm:p-5 flex-col gap-y-5 sm:gap-y-7 rounded-xl">
            <span className="text-lg sm:text-xl text-start font-semibold text-[#050B10]">
              Contact information
            </span>

            <div className="flex flex-col gap-y-4 w-full -mt-2">
              <div className="flex flex-col lg:flex-row items-center justify-between w-full space-y-4 lg:space-y-0 lg:space-x-3">
                <div className="flex flex-col gap-y-2 w-full">
                  <span className="text-xs sm:text-sm font-medium text-[#4F5762]">
                    Full Name <span className="text-red-500">*</span>
                  </span>
                  <input
                    type="text"
                    name="name"
                    className="w-full border border-borderColor placeholder:font-normal placeholder:text-xs placeholder:text-[#808080] rounded-xl shadow-box outline-none bg-transparent p-2 sm:p-3 text-sm"
                    placeholder="Enter your full name"
                  />
                </div>
                <div className="flex flex-col gap-y-2 w-full">
                  <span className="text-xs sm:text-sm font-medium text-[#4F5762]">
                    Email Address <span className="text-red-500">*</span>
                  </span>
                  <input
                    type="email"
                    name="email"
                    className="w-full border border-borderColor placeholder:font-normal placeholder:text-xs placeholder:text-[#808080] rounded-xl shadow-box outline-none bg-transparent p-2 sm:p-3 text-sm"
                    placeholder="Enter your email"
                  />
                </div>
              </div>
              <div className="flex flex-col gap-y-2 w-full">
                <span className="text-xs sm:text-sm font-medium text-[#4F5762]">
                  Subject <span className="text-red-500">*</span>
                </span>
                <input
                  type="text"
                  name="subject"
                  className="w-full border border-borderColor placeholder:font-normal placeholder:text-xs placeholder:text-[#808080] rounded-xl shadow-box outline-none bg-transparent p-2 sm:p-3 text-sm"
                  placeholder="Enter a subject"
                />
              </div>
              <div className="flex flex-col gap-y-2 w-full">
                <span className="text-xs sm:text-sm font-medium text-[#4F5762]">
                  Description <span className="text-red-500">*</span>
                </span>
                <textarea
                  rows={5}
                  name="description"
                  className="w-full resize-none border border-borderColor placeholder:font-normal placeholder:text-xs placeholder:text-[#808080] rounded-xl shadow-box outline-none bg-transparent p-2 sm:p-3 text-sm"
                  placeholder="Enter details"
                />
              </div>
            </div>

            <ButtonV2
              title="Submit Feedback"
              loaderColor="#ffffff"
              textStyle="text-white font-medium text-xs sm:text-sm"
              handleClick={() => {}}
              image={CHEVRON_RIGHT_WHITE}
              btnStyle="flex px-4 sm:px-5 items-center justify-center py-2 sm:py-3 rounded-full bg-globalGreen gap-x-2 text-white font-medium text-sm sm:text-[16px]"
            />
          </div>
        </div>
      </div>
    </LandingPageLayout>
  );
}

export default ContactUs;
